<template>
  <InvalidProduct
    v-if="showInvalidProduct || sourcingStatusInfo.status === 3"
    :reason="sourcingStatusInfo?.message"
  />
  <div
    v-else
    class="container-detail"
  >
    <div v-show="!showEmpty && emptyObj?.code !== 5209">
      <div class="container-main">
        <Carousel />
        <OfferInfo
          ref="offerInfoRef"
          @selected-sku-id="handleSelectedSkuId"
          :sourcing-status-info="sourcingStatusInfo"
        />
        <Sourcing
          @add-cart-success="handleAddSuccess"
          @soucing-success="handleSoucingSuccess"
          :show-tips="showTips"
        />
      </div>
      <div>
        <OfferDetailInfo />
      </div>
    </div>
    <SideCart ref="sideCartRef" />
    <EmptyOffer v-show="showEmpty && emptyObj?.code !== 5209" />
    <Empty
      v-if="emptyObj?.code === 5209"
      :msg="emptyObj?.msg || 'Sorry, no results found'"
    />
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { computed, onMounted, ref } from 'vue'
import { buriedPointUtil, gaAnalytics, waitForIntercom } from '../../../../utils/utils'
import { fetchData } from '../../../../utils/fetch'
import Empty from '@/components/Empty/index.vue'
import Carousel from '@/components/Offer/Carousel/index.vue'
import OfferInfo from '@/components/Offer/OfferInfo/index.vue'
import Sourcing from '@/components/Offer/Sourcing/index.vue'
import OfferDetailInfo from '@/components/Offer/OfferDetailInfo/index.vue'
import EmptyOffer from '@/components/Offer/EmptyOffer/index.vue'
import SideCart from './components/SideCart.vue'
import InvalidProduct from './components/InvalidProduct.vue'
import { useUserStore } from '@/pinia/user'

const route = useRoute()
const store = useStore()
const offerId = route.params.id

const showEmpty = ref(false)

const sourcingStatusInfo = ref({
  skuList: [],
  status: ''
})

const emptyObj = computed(() => store.state.emptyObj)

const user = useUserStore()

const buriedEmail = () => {
  const { emailType = '', email_id = '', orderNo = '' } = route.query
  if (emailType) {
    buriedPointUtil({ eventId: 'PPD501', emailId: atob(email_id) })
    !!orderNo && waitForIntercom(orderNo)
  }
}

const showInvalidProduct = ref(false)
const detailData = ref(null)
const getDetail = async () => {
  try {
    showEmpty.value = true
    store.commit('setLoading', true)
    const { code, data, msg } = await fetchData('/dsp-app/alibaba-common/searchProductDetail', {
      method: 'post',
      body: JSON.stringify({
        offerId
      })
    })

    if (code === 200) {
      detailData.value = data
      store.commit('setOfferDetail', data)
      store.commit('setLoading', false)
      showEmpty.value = false

      if (user.isLogged) {
        getSkuCartStatus(data)
      }
    }
    if (code === 500) {
      showEmpty.value = false
      store.commit('setLoading', false)
      if (msg === 'The product does not exist.') {
        showInvalidProduct.value = true
      }
    }
  } catch (error) {
    showEmpty.value = false
    store.commit('setLoading', false)
  }
}

// 获取购物车商品状态
const skuCartStatus = ref([])
const getSkuCartStatus = async (obj) => {
  const offerId = obj.offerId
  const params = {
    spuId: offerId,
    skuIds: obj.productSkuInfos.map(item => item.skuId)
  }
  const { code, data } = await fetchData('/appb/b2b/cart/getPendingSkuBySpu', {
    method: 'post',
    body: JSON.stringify(params)
  })
  skuCartStatus.value = data || []

  // 默认会选中第一个sku, 所以需要触发一次
  handleSelectedSkuId(obj.productSkuInfos[0].skuId)
}

const offerInfoRef = ref(null)
const sideCartRef = ref(null)
const handleAddSuccess = () => {
  offerInfoRef.value.resetData()
  sideCartRef.value.getCartSkuList()
  getSkuCartStatus(detailData.value)
}

const handleSoucingSuccess = () => {
  offerInfoRef.value.resetData()
  getSourcingStatus()
}

const getSourcingStatus = async () => {
  const offerId = route.params.id

  const { code, data } = await fetchData('/appb/alibaba-common/offerDetail/sourcingStatusV2', {
    method: 'POST',
    body: JSON.stringify({
      offerId,
      skuIds: detailData.value.productSkuInfos.map(item => item.skuId)
    })
  })

  if (code === 200) {
    sourcingStatusInfo.value = data
  }
}

const showTips = ref(false)
const handleSelectedSkuId = (skuId) => {
  showTips.value = skuCartStatus.value.includes(String(skuId))
}

onMounted(async () => {
  gaAnalytics('p_product_detail_page_view', 'p_product_detail_page_view', { spuId: offerId })
  buriedPointUtil({ eventId: 'PEX101', others: { offerIdList: [offerId] } })

  await getDetail()
  getSourcingStatus()
  buriedEmail()
})

</script>

<style lang="less">
.container-detail {
  width: 1200px;
  margin: 24px auto 38px;

  .container-main {
    position: relative;
    display: flex;
    column-gap: 16px;
  }
}
</style>
